import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getHomeServices } from "../../features/services/serviceSlice"
import ServicesSlider from "./ServicesSlider"

import { Box, CircularProgress, Typography } from "@mui/material"
import { motion } from "framer-motion"

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
}

const ServicesSection = () => {
  const dispatch = useDispatch()

  const { loading, error, homeServices } = useSelector(
    (state) => state.services
  )

  useEffect(() => {
    dispatch(getHomeServices())
  }, [dispatch])

  return (
    <Box component="section" py={8}>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error" sx={{ textAlign: "center", mt: 6 }}>
          {error}
        </Typography>
      ) : homeServices && homeServices.length > 0 ? (
        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeIn}
        >
          <ServicesSlider services={homeServices} />
        </motion.div>
      ) : (
        <Typography sx={{ textAlign: "center", mt: 6 }}>
          No services found.
        </Typography>
      )}
    </Box>
  )
}

export default ServicesSection
